import { useParams } from "react-router-dom";
import { useWarehouses } from "../WarehousesProvider";

export function useWarehouseFromRoute() {
  const { warehouseId } = useParams<"warehouseId">();
  const [warehouses] = useWarehouses();

  return warehouses?.find((warehouse) => warehouse.id === warehouseId);
}
